/**
 * Runtime constants shared by the API and the tablet for offline sign-in. Kept apart from
 * index.ts so the tablet can import them without pulling Zod into its bundle.
 */

/** How offline PIN checks are computed: base64url(PBKDF2-SHA256(pin, salt, iterations, 256 bits)). */
export const OFFLINE_PIN_CHECK = {
  iterations: 100_000,
  /** Scope = the hospital's id as text ("2"), or SERVICE_SCOPE for service accounts. */
  salt: (scope: string) => `evesix-offline:${scope}`,
} as const;

/** The PIN scope of a service account: it belongs to no hospital and works on every robot. */
export const SERVICE_SCOPE = '*';
